import React, { useState } from 'react';
import { Tag } from 'lucide-react';
import PanneauLabelsObjectifs from './PanneauLabelsObjectifs';

/**
 * Ouvre le panneau « Labels et objectifs » du compte affiché.
 *
 * ## Pourquoi ici, et pas dans l'en-tête du dashboard
 *
 * Il n'existe aucun en-tête propre aux dashboards de régie. Le plus proche est le bandeau collant
 * de filtres, recopié huit fois dans `App.js` pour les seuls Google, Microsoft et Meta, et absent
 * de TikTok, Awin et ChatGPT Ads. Ce bouton est donc posé dans l'en-tête du **module Campagnes**
 * (`CampaignsTable`), qui est partagé : une seule pose couvre les six dashboards ayant un tableau
 * de campagnes, et le bouton se trouve juste au-dessus de la liste qu'on vient étiqueter.
 *
 * ## L'icône
 *
 * `Tag`, la même que le filtre par label du bandeau, et non l'engrenage `Settings` déjà pris par
 * la configuration des métriques juste à côté. Deux engrenages voisins ouvrant deux choses
 * différentes se confondraient.
 */
function BoutonReglagesCampagnes({ accountId, accountType, nomCompte, userRole, token }) {
  const [ouvert, setOuvert] = useState(false);

  // Consultation seule pour les accès clients, comme l'engrenage des métriques voisin.
  // Sans compte résolu, il n'y a rien à régler : le bouton ne s'affiche pas plutôt que d'ouvrir
  // un panneau vide.
  if (userRole === 'CLIENT' || !accountId) return null;

  return (
    <>
      <button
        onClick={() => setOuvert(true)}
        className="metrics-settings-btn"
        title="Labels et objectifs des campagnes"
        aria-label="Labels et objectifs des campagnes"
      >
        <Tag size={16} />
      </button>

      <PanneauLabelsObjectifs
        isOpen={ouvert}
        onClose={() => setOuvert(false)}
        accountId={accountId}
        accountType={accountType}
        nomCompte={nomCompte}
        token={token}
      />
    </>
  );
}

export default BoutonReglagesCampagnes;
